import { createContext, useContext, type ReactNode } from "react";

export type ToastTone = "neutral" | "success" | "warning" | "danger" | "info";

export interface ToastOptions {
  tone?: ToastTone;
  /** Short outcome sentence: "Avatars off for 40 mappings". */
  title: ReactNode;
  message?: ReactNode;
  /** Optional action, e.g. a Retry or Undo button. */
  action?: ReactNode;
  /** Auto-dismiss after ms; default 5000. 0 keeps it until dismissed. */
  duration?: number;
  /** Supply to replace an existing toast with the same id (e.g. job progress updates). */
  id?: string;
}

export interface ToastApi {
  show: (options: ToastOptions) => string;
  dismiss: (id: string) => void;
  clear: () => void;
}

export const ToastContext = createContext<ToastApi | null>(null);

/** Access the toast queue. Must be inside <ToastProvider>. */
export function useToast(): ToastApi {
  const api = useContext(ToastContext);
  if (!api) throw new Error("useToast() must be used inside <ToastProvider>");
  return api;
}

export const TOAST_DEFAULT_DURATION = 5000;
